<template>
  <v-row>
    <v-col cols="12" class="pt-0" v-if="hosting_error">
      <v-card class="app-card" text>
        <v-card-text>
          <p class="mb-0">{{ hosting_error }}</p>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" v-else>
      <reseller-accounts-list :loading="loading" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import ResellerAccountsList from 'Components/Services/Hosting/Reseller/ResellerAccountsList'

export default {
  name: 'HostingWhmListAccounts',
  components: {
    ResellerAccountsList,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: mapGetters(['hosting_error']),
}
</script>
